import "@nickeylin/taroify-icons/style"
import "../base.scss"
